
import React, { useCallback } from "react";
import { useUserStore, } from "../../../state";
import { useLoginStore } from "../../../state/LoginStore";

export function useHandleAcceptTerms(setMFA: React.Dispatch<any>) {
    const setUserConfig = useUserStore(state => state.setUserConfig)
    const setTermsAccepted = useLoginStore(state => state.setTermsAccepted)
    const setUserAcceptingTerms = useLoginStore(state => state.setUserAcceptingTerms)
    const userConfig = useUserStore(state => state.userConfig)

    const handleAcceptTerms = useCallback(
        async () => {
            setUserConfig({
                ...userConfig,
                loggedIn: true
            })
            setTermsAccepted(true)
            setUserAcceptingTerms(false)
            setMFA(false)
        }, [userConfig, setMFA, setTermsAccepted, setUserAcceptingTerms, setUserConfig]
    )

    return { handleAcceptTerms };

}